import {h} from 'preact';

const Icon = ({name, customClasses = 'w-6 h-6'}) => {
  switch (name) {
    case 'close':
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          aria-label='{{ aria_label }}'
          aria-hidden='true'
        >
          <path d="M20 4L4 20" stroke="currentColor"/>
          <path d="M4 4L20 20" stroke="currentColor"/>
        </svg>
      );
    case 'gift':
      return (
        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation">
          <rect x="0.5" y="3.99988" width="10" height="8" stroke="currentColor"/>
          <path d="M8.66667 3.9999C9.55556 3.4999 10 2.8749 10 2.00003C10 1.60224 9.84949 1.22074 9.58158 0.939459C9.31367 0.658179 8.95031 0.500158 8.57143 0.500158C6.84298 0.500158 6 2.5 6 3.9999" stroke="currentColor" strokeLinejoin="round"/>
          <path d="M2.33333 3.9999C1.44444 3.49987 1 2.87484 1 1.99994C1 1.60213 1.15051 1.22061 1.41842 0.939321C1.68633 0.658029 2.04969 0.5 2.42857 0.5C4.15702 0.5 5 2.49993 5 3.9999" stroke="currentColor" strokeLinejoin="round"/>
          <path d="M0.5 6.5H10.5" stroke="currentColor"/>
          <path d="M4.5 4.5V12M6.5 4.5V12" stroke="currentColor"/>
        </svg>
      );
    case 'carret':
      return (
        <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path id="Arrow Right" d="M1 0.5L5 4.5L1 8.5" stroke="currentColor" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    case 'dot':
      return(
        <svg width="3" height="4" viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="1.5" cy="2" r="1.5" fill="#D22D2D"/>
        </svg>
      );
    case 'icon-check':
      return(
        <svg
          width='12'
          height='9'
          viewBox='0 0 12 9'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          aria-hidden='true'
          className={customClasses}
        >
           <path d="M1.33333 3.99996L4.44444 7.33329L10.6667 0.666626" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      )
    default:
      return null;
  }
}

export default Icon;
